import { generateNewQuestionWithIA } from 'core/crud/questions.crud';
import { useState } from 'react';

const useDialogAIGeneratedActivity = ({ course, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [topic, setTopic] = useState('');

  async function onGenerate() {
    console.log('course', course);
    setError(false);
    setLoading(true);
    let discipline = course?.discipline_name || '';
    let edYear = course?.education_year_name || '';
    let edlevel = course?.education_level_name || '';
    let country = getCountry(course?.digital_program_langs[0]?.id);
    let language = getLanguage(course?.digital_program_langs[0]?.id);

    const system = `You are an educator specializing in ${discipline}, teaching ${edYear} ${edlevel} students in ${country}. Your task is to devise engaging and effective activities in ${language} that will aid your students in mastering the provided topics.`;
    const prompt = `Using this instructions: Create just one valid JSON object. That includes 3 to 6 options, ensuring only one correct answer for each question. Make just one question. The json should cover the given \"${topic}"\ .Following this format: { \"statement\": 'Question statement', \"options\":[{\"title\": \"Text of option right\", \"correct\": \"true or false\"}] } The JSON object: .trim()`;

    const responseAi = await generateNewQuestionWithIA({
      system,
      prompt,
      model: 'gpt-4',
    });
    if (!responseAi.data.data) {
      setError(true);
    } else {
      const questionData = responseAi.data.data;
      onSuccess(questionData);
    }
    setLoading(false);
    setTopic('');
  }

  function onChangeTopic(newTopic) {
    setTopic(newTopic);
  }

  function getCountry(country) {
    if (country === 'pt') return 'Portugal';
    if (country === 'br') return 'Brasil';
    if (country === 'mx') return 'México';
    if (country === 'es') return 'Spain';
    return country || 'Spain';
  }

  function getLanguage(language) {
    if (language === 'pt') return 'portuguese';
    if (language === 'br') return 'portuguese';
    if (language === 'mx') return 'spanish';
    if (language === 'es') return 'spanish';
    return language || 'spanish';
  }

  return { loading, error, topic, onChangeTopic, onGenerate };
};

export default useDialogAIGeneratedActivity;
